import CameraController from "../../output/assets/camera/camera-controller.js";

class ThreeCameraController extends CameraController {
    constructor(camera) {
        super();

        this._camera = camera;
        this._target = null;
    }

    setPosition(x, y, z) {
        this._camera.position.set(x, y, z);

        if (this._target) {
            const { x, y, z } = this._target;
            this._camera.lookAt(x, y, z);
        }
    }

    setTarget(x, y, z) {
        let target = this._target;

        if (!target) {
            target = {};
            this._target = target;
        }

        target.x = x;
        target.y = y;
        target.z = z;

        this._camera.lookAt(x, y, z);
    }

    setFov(fov) {
        this._camera.fov = fov;
    }

    setZoom(zoom) {
        this._camera.zoom = zoom;
    }

    setNear(near) {
        this._camera.near = near;
    }

    setFar(far) {
        this._camera.far = far;
    }
}

export default ThreeCameraController;
